import React from "react";
import { Button, Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import EditTransaction from "./EditTransaction";
import NavBar from "../../Components/NavBar";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount from "../../../Components/etc/RenderAmount";
import AccountDetails from "../AccountsScreen/AccountDetails";
import TransactionDetails from "./TransactionDetails";

const SCREEN_NAME = "TRANSACTIONS_SCREEN";

class TransactionsScreen extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      transactions: [],
      triggerReload: 0,
    };

    const columns = this.props.table?.columns
      ? this.props.table?.columns
      : [
          {
            value: "t",
            label: "Date",
            render: ({ item }) => new Date(item.t).toLocaleString(),
          },
          {
            value: "account.shortId",
            label: "Account ID",
            render: ({ item }) => (
              <div
                className="hoveredlink"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setAsyncState({
                    visibleModal: "accountDetails",
                    modalData: { account: item.account },
                  });
                }}
              >
                {item.account?.shortId}
              </div>
            ),
          },
          {
            value: "name",
            label: "Name",
            render: ({ item }) => getFullName(item.customer),
          },
          {
            value: "transactionType",
            label: "Type",
            render: ({ item }) => _.startCase(item.transactionType),
          },
          {
            value: "credit",
            label: "Credit",
            render: ({ item }) => (
              <RenderAmount value={item.side === "credit" && item.amount} />
            ),
          },
          {
            value: "debit",
            label: "Debit",
            render: ({ item }) => (
              <RenderAmount value={item.side === "debit" && item.amount} />
            ),
          },
          {
            value: "balance",
            label: "Balance",
            render: ({ item }) => <RenderAmount value={item.balance} />,
          },

          {
            value: "note",
            label: "Note",
            render: ({ item }) => <div className="multiline">{item.note}</div>,
          },
        ];

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }
  }

  async retriveData(query) {
    const { transactions } = await api.get("v1/transaction", query);
    return transactions;
  }

  async setItems(items) {
    if (this.props.contentOnly) this.setAsyncState({ transactions: items });
    else this.props.setScreenState({ transactions: items });
  }

  getItems() {
    if (this.props.contentOnly) return this.state.transactions;
    else return this.props.transactions;
  }

  onNewTransaction(item) {
    this.setAsyncState({
      visibleModal: null,
      modalData: null,
      triggerReload: Date.now(),
    });

    this.props.onNewTransaction?.(item);
  }

  render() {
    const {
      state: { visibleModal, modalData, triggerReload },
    } = this;

    const content = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">Transactions</div>
          </div>
          <div className="right">
            <Button
              variant="secondary"
              onClick={() => this.setAsyncState({ triggerReload: Date.now() })}
            >
              Reload
            </Button>
            <Button
              onClick={() =>
                this.setAsyncState({
                  visibleModal: "editTransaction",
                  modalData: null,
                })
              }
              disabled={this.props.account?.closed}
            >
              Record Transaction
            </Button>
          </div>
        </div>

        <div>
          <ItemList
            {...{
              defaultQuery: {
                populate: "account customer collector",
              },
              additionalQueries: this.props.additionalQueries,
              triggerReload,
              items: this.getItems(),
              table: {
                columns: this.columns,
                onRowClick: ({ item, index }) =>
                  this.setAsyncState({
                    visibleModal: "transactionDetails",
                    modalData: { transaction: item, index },
                  }),
              },
              retriveData: this.retriveData.bind(this),
              setItems: this.setItems.bind(this),
              scrollSelector: this.props.scrollSelector,
            }}
          />
        </div>

        <EditTransaction
          {...{
            key: `editTransaction-${
              visibleModal === "editTransaction"
                ? modalData?.transaction?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "editTransaction",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewTransaction(item),
            account: this.props.account,
            ...(modalData || {}),
          }}
        />

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />

        <TransactionDetails
          {...{
            key: `transactionDetails-${
              visibleModal === "transactionDetails"
                ? modalData?.transaction?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "transactionDetails",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            ...(modalData || {}),
          }}
        />
      </div>
    );

    if (this.props.contentOnly) {
      return content;
    }

    return (
      <>
        <NavBar activeLink="/transaction" />
        <Container className="gainner">{content}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  transactions: state.vState[SCREEN_NAME]?.transactions || [],
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsScreen);
